import Pagination from 'antd-mobile/lib/pagination';
export default Pagination;



// WEBPACK FOOTER //
// ./components/pagination/index.tsx